export enum HelpSubjectType {
  ROTARDA_MIL = 'RotardaMil',
  AVANS_MIL = 'AvansMil',
}
